import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const FILTERS = [["open", "Aperte"], ["resolved", "Risolte"], ["dismissed", "Archiviate"], ["all", "Tutte"]];
const small = "px-3 py-1.5 text-[11px] uppercase tracking-[0.12em] border transition-colors";

export const AdminReports = ({ onChange }) => {
  const [status, setStatus] = useState("open");
  const [list, setList] = useState(null);
  const load = useCallback(() => api.get("/admin/reports", { params: { status } }).then((r) => setList(r.data)), [status]);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, msg) => {
    try { await fn(); toast.success(msg); load(); onChange(); } catch (e) { toast.error(formatApiError(e)); }
  };
  const hideTarget = (r) => act(() => api.post(r.target_type === "hostess" ? `/admin/users/${r.target_id}/hide` : `/admin/events/${r.target_id}/hide`, { value: !r.target.hidden }),
    r.target.hidden ? "Reso di nuovo visibile" : "Nascosto");
  const resolve = (r, s) => act(() => api.post(`/admin/reports/${r.id}/resolve`, { status: s }), s === "resolved" ? "Segnalazione risolta" : "Segnalazione archiviata");

  return (
    <div className="mt-8" data-testid="admin-reports">
      <div className="flex flex-wrap gap-2">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setStatus(v)} data-testid={`admin-reports-filter-${v}`}
            className={`${small} ${status === v ? "border-[#D4AF37] text-[#D4AF37]" : "border-white/10 text-neutral-400 hover:border-white/30"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-6 space-y-3">
        {list?.length === 0 && <p className="text-neutral-500 border border-white/5 p-10 text-center" data-testid="admin-reports-empty">Nessuna segnalazione</p>}
        {(list || []).map((r) => (
          <div key={r.id} className="bg-[#121418] border border-white/5 p-5 flex flex-col lg:flex-row lg:items-center gap-4" data-testid={`admin-report-${r.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <span className="eyebrow">{r.target_type === "hostess" ? "Profilo" : "Evento"}</span>
                <span className="text-[10px] uppercase tracking-widest border border-red-400/30 text-red-400 px-2 py-0.5">{r.reason_label}</span>
                {r.target_reports > 1 && <span className="text-[10px] font-mono text-neutral-400">{r.target_reports} segnalazioni</span>}
                {r.target?.hidden && <span className="text-[10px] uppercase tracking-widest text-neutral-500 border border-white/10 px-2 py-0.5">Nascosto</span>}
              </div>
              {r.target ? <Link to={r.target.link} className="font-serif text-2xl mt-2 block hover:text-[#D4AF37] truncate" data-testid={`admin-report-target-${r.id}`}>{r.target.name}</Link>
                : <p className="font-serif text-2xl mt-2 text-neutral-500">Elemento eliminato</p>}
              {r.details && <p className="text-sm text-neutral-400 mt-1 italic break-words">“{r.details}”</p>}
              <p className="text-[11px] font-mono text-neutral-500 mt-2">da {r.reporter?.name} ({r.reporter?.email}) · {new Date(r.created_at).toLocaleString("it-IT")}</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {r.target && <button onClick={() => hideTarget(r)} className={`${small} border-red-400/40 text-red-400 hover:bg-red-400/10`} data-testid={`admin-report-hide-${r.id}`}>{r.target.hidden ? "Rendi visibile" : "Nascondi"}</button>}
              {r.status === "open" && <button onClick={() => resolve(r, "resolved")} className={`${small} border-emerald-400/40 text-emerald-400 hover:bg-emerald-400/10`} data-testid={`admin-report-resolve-${r.id}`}>Risolta</button>}
              {r.status === "open" && <button onClick={() => resolve(r, "dismissed")} className={`${small} border-white/15 text-neutral-400 hover:border-white/40`} data-testid={`admin-report-dismiss-${r.id}`}>Archivia</button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
